module.exports = __webpack_public_path__ + "img/ter-ovanesov.911405fe.jpg";